function NotFoundPage() {

  return (
    <div className="page-error">
        <div className="wrapper">
            <h1>
                404
            </h1>
            <div className="descr">
                Page not found
            </div>
        </div>
    </div>
  )
}

export {NotFoundPage}
